import voteApi from '~/clientApis/voteApi';
import { VoteData } from '~/definitions/vote';
import { getStore } from '~/mobx/AppStore';
import generateNorwegianTimestamp from '~/utils/generateNorwegianTimestamp';

const submitVote = async () => {
    const { voteStore } = getStore();

    // Update the votes timestamp
    const ts = generateNorwegianTimestamp();
    const updatedVotes = voteStore.votes.map((vote) => {
        return {
            ...vote,
            ts,
        };
    });

    // Prepare the data for submission
    const votesByCandidate: VoteData[] = updatedVotes.map((vote) => {
        const key = `vote:${vote.region_id}:${vote.user_id}:${vote.candidate_id}`;
        return {
            key,
            value: { ...vote },
        };
    });

    voteStore.setIsVoteInProgress(true);

    try {
        const response = await voteApi.saveVote(votesByCandidate);
        if (response?.success) {
            voteStore.setVoteStatus('success');
        } else {
            // Handle the case where the user has already voted or other failure
            voteStore.setVoteStatus('error');
        }
    } catch (error) {
        voteStore.setVoteStatus('error');
    } finally {
        voteStore.setIsVoteInProgress(false);
    }
};
export default submitVote;
